import Vue from 'vue'
import { CodingInformationApiAdapter } from '../adapter/CodingInformationApiAdapter'
import { CodingInformation } from '../classes/CodingInformation'
import { AllergyStore } from '../types/AllergyStore'
import Allergy from '../classes/Allergy'
import { AllergyAPIAdapter } from '../adapter/AllergyApiAdapter'
import { AllergyRefReactionAPIAdapter } from '../../../dPpatients/vue/Adapter/AllergyRefReactionApiAdapter'
import AllergyRefReaction from '../../../dPpatients/vue/Classes/AllergyRefReaction'
import { AllergyReactionStore } from '../../../dPpatients/vue/Type/AllergyReactionStore'
import { AllergyAllergenStore } from '../../../dPpatients/vue/Type/AllergyAllergenStore'
import AllergyRefAllergen from '../../../dPpatients/vue/Classes/AllergyRefAllergen'
import { AllergyRefAllergenAPIAdapter } from '../../../dPpatients/vue/Adapter/AllergyRefAllergenApiAdapter'
import { tap } from 'rxjs/operators'
import { allergyCategoryEnum } from '../../../dPpatients/vue/Enum/allergyCategoryEnum'
import { AllergiesPatient } from '../types/AllergiesPatient'
import CommonHelper from '../../../system/vue/Classes/CommonHelper'
import { JsonApiResponseAdapter, KhDate } from '@internal-libraries/kheops-ui-lib'
import Stay from '../../../dPplanningOp/vue/Classes/Stay'
import { StRehaStayAPIAdapter } from '../../../soins/vue/adapter/StRehaStayAPIAdapter'

export default {
    loadCodingInformation({ commit }, id): Promise<CodingInformation> {
        const apiCall = Vue.prototype.$http.get('api/v1/ssr/codingview/' + id, new CodingInformationApiAdapter())
        apiCall.subscribe((response) => {
            const result = response.getManyData()
            commit('saveCodingInformation', result)
        })
        return apiCall.toPromise()
    },
    createAllergyFoodPatient({ commit }, args: AllergyStore): Promise<Allergy> {
        return Vue.prototype.$http
            .post(
                'api/v1/allergy/allergy?populate=refLinkedObject&is_active=0,1&patient_id=' + args.parameters.patient_id,
                new AllergyAPIAdapter(),
                args.parameters
            )
            .pipe(
                tap((addedAllergy: JsonApiResponseAdapter<Allergy>) =>
                    commit('createAllergyFoodPatient', { allergy: addedAllergy.getManyData(), storeKey: args.storeKey })
                )
            )
            .toPromise()
    },
    loadStayWithPatient(data, stayId: string): Promise<Stay> {
        return Vue.prototype.$http
            .get(
                'api/v1/planning/stay/' + stayId + '?fieldsets=all',
                new StRehaStayAPIAdapter()
            )
            .toPromise()
    },
}
